import Base from '../common/Base';
import './index.scss';

// 自下划入动画组件
function SlideRight(props) {
  return (<Base classNames="slide-right" {...props}></Base>);
}

export default SlideRight;